/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import useRequests from '../../hooks/useRequests';

const WhatsAppOnboardingPage = () => {
  const requests = useRequests();

  function sendData(eventData) {
    requests.post('https://n8n.cloud.kesildigital.com/webhook/whatsapp-completion', {
      event_data: eventData,
      isValidJson: eventData && typeof eventData === 'object',
    });
  }

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin !== 'https://www.facebook.com' && event.origin !== 'https://web.facebook.com') {
        return;
      }

      try {
        const data = JSON.parse(event.data);

        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH') {
            console.log('✅ Embedded Signup completado', data);
            sendData(data);
          }

          if (data.event === 'CANCEL') {
            console.warn('⛔️ Usuario canceló el Embedded Signup');
          }

          if (data.event === 'ERROR') {
            console.error('❌ Error en Embedded Signup:', data);
            sendData(data);
          }
        }
      } catch (e) {
        console.log(e);
        console.log('⚠️ Non-JSON response:', event.data);
        sendData(event.data);
      }
    });

    // Cargar SDK solo una vez
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      document.body.appendChild(script);
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '2219470115115225',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v17.0',
      });
    };
  }, []);

  const launchWhatsAppSignup = () => {
    window.FB.login(() => {}, {
      config_id: '975077101445759',
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: 'whatsapp_business_app_onboarding',
        sessionInfoVersion: '2',
      },
    });
  };

  return (
    <section className="wpo-contact-pg-section">
      <div className="container">
        <div className="row">
          <div className="wpo-contact-title">
            <section style={{ padding: '2rem', maxWidth: '900px', margin: 'auto', fontFamily: 'sans-serif' }}>
              <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem' }}>Crea tu número de WhatsApp para automatizaciones</h2>
              <p style={{ fontSize: '1.1rem', color: '#444' }}>
                Configura un número exclusivo para tu empresa y comienza a enviar mensajes automatizados a tus clientes usando la API oficial de
                WhatsApp. Este proceso está respaldado por Meta.
              </p>

              <h3 style={{ marginTop: '2rem', marginBottom: '1.5rem' }}>✅ ¿Qué necesitas para comenzar?</h3>
              <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', color: '#333', textAlign: 'left' }}>
                <li>Una cuenta de Facebook con acceso a Business Manager</li>
                <li>
                  Un nombre para mostrar en WhatsApp
                  <br />
                  <small style={{ color: '#666' }}>(puede ser el de tu marca, negocio o cualquier nombre comercial válido)</small>
                </li>
                <li>Una dirección de correo electrónico de contacto</li>
                <li>
                  Un número de teléfono que <strong>no esté en uso</strong> en la app de WhatsApp o WhatsApp Business
                </li>
                <li>Acceso para recibir una llamada o SMS a ese número durante la configuración</li>
              </ul>
              <div
                style={{
                  marginTop: '1.5rem',
                  backgroundColor: '#f8f9fa',
                  padding: '1rem',
                  borderRadius: '0.5rem',
                  fontSize: '0.95rem',
                  color: '#333',
                }}
              >
                💡 <strong>Importante:</strong> Este número será exclusivo para integraciones por API. No podrás usarlo con la app móvil de WhatsApp
                ni en WhatsApp Web.
              </div>
            </section>
            <button
              onClick={launchWhatsAppSignup}
              style={{
                marginTop: '2rem',
                backgroundColor: '#25D366',
                color: '#fff',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              Empezar configuración
            </button>
          </div>
        </div>
      </div>
      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map"></div>
      </section>
    </section>
  );
};

export default WhatsAppOnboardingPage;
